var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTrash = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19391",
  transform: "translate(-229 -731)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  fill: "rgba(0,0,0,0)",
  "data-name": "Ellipse 1561",
  transform: "translate(229 731)"
}), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  "data-name": "Group 15458"
}, /*#__PURE__*/React.createElement("path", {
  d: "M233 735h24v24h-24z",
  "data-name": "Rectangle 2366"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  "data-name": "Group 9155"
}, /*#__PURE__*/React.createElement("path", {
  d: "M251.737 742.166a82 82 0 0 0-8.045-.4 47 47 0 0 0-4.769.241l-1.639.159",
  "data-name": "Path 1587"
}), /*#__PURE__*/React.createElement("path", {
  d: "m241.7 741.356.177-1.052c.128-.763.223-1.333 1.581-1.333h2.1c1.357 0 1.461.6 1.582 1.341l.177 1.044",
  "data-name": "Path 1588"
}), /*#__PURE__*/React.createElement("path", {
  d: "m250.01 744.704-.522 8.086c-.088 1.261-.161 2.24-2.4 2.24h-5.155c-2.24 0-2.312-.98-2.4-2.24l-.523-8.086",
  "data-name": "Path 1589"
}))))));
export { SvgTrash as ReactComponent };
export default __webpack_public_path__ + "static/media/trash.a5b29014e58e67e338a75a9db5732848.svg";